<nav class="footer-social">
	<a title="facebook" href="https://www.facebook.com/mynatomame1" target="_blank"><app-icon class="social-icon" name="facebook"></app-icon></a>
	<a title="instagram" href="https://www.instagram.com/mynatomame.cz" target="_blank"><app-icon class="social-icon" name="instagram"></app-icon></a>
	<a title="youtube" href="https://www.youtube.com/channel/UCP2kxPN0ocObl-Xcs5ejxWw/featured" target="_blank"><app-icon class="social-icon" name="youtube"></app-icon></a>
</nav>

<nav class="footer-navigation">
	<ul class="main-navigation">
	  <li class="main-section" *ngFor="let page of (routes$ | push)" routerLinkActive="active">
	    <app-route-link class="section-route-link" [route]="page">
	      	</app-route-link>
	    <ul class="main-routes">
	      <li class="main-route" *ngFor="let subPage of page.children" routerLinkActive="active" matRipple>
	        <app-route-link class="main-route-link" [route]="subPage">
	      	</app-route-link>
	      </li>
	    </ul>
	  </li>
	  <li class="main-section">
	  	<app-route-link class="section-route-link" [route]="about">
	      	</app-route-link>
	  	<ul class="main-routes">
	  	  <li class="main-route" *ngFor="let subPage of (about$ | push)" routerLinkActive="active" matRipple>
	  	    <app-route-link class="main-route-link" [route]="subPage">
	  	  	</app-route-link>
	  	  </li>
	  	</ul>
	  </li>
	</ul>
</nav>



<p class="copy">&copy; 2022 - MY NA TO MÁME</p>
